// [ ] Task: 1205
import React, { useState, useMemo, useEffect } from "react";
import RightSidebar from "./RightSidebar";
import StepTabs from "./StepTabs";
import BottomBar from "./BottomBar";
import "./TransactionDetail.css";
import { PropertyInfoForm } from "./forms/property-info/propertyInfoForm";
import { Modal } from "./ui/Modal";
import useCountries from "../hooks/useCountries";
import { usePropertyData } from "../hooks/usePropertyData";
import FloatingMessageCenter from "./FloatingMessageCenter";
import AddressUpdateConfirmationModal from "./ui/AddressUpdateConfirmationModal";
import FloatingQueryCenter from "./FloatingQueryCenter";
import ConfirmationModal from "./ui/ConfirmationModal";
import PropertyConfirmModal from "./ui/PropertyConfirmModal";
import { useNavigate } from "react-router-dom";
import ViewModeBanner from "./ui/ViewModeBanner";

const PropertyInfo = ({isReport}) => {



  

  
  const [activeTab, setActiveTab] = useState("step2");
  const countries = useCountries();
  const {
    isSelectorReadOnly,
    searchParams,
    hasUnsavedChanges,
    isReadOnly,
    setIsReadOnly,
    modalOpen,
    modalMessage,
    modalHeading,
    formData,
    existingProperty,
    handleChange,
    setModalOpen,
    handleValidate,
    handleUpdate,
    handlePropertyChange,
    handleNext,
    entityId,
    showAddressModal,
    validationResult,
    setShowAddressModal,
    pendingUpdatedData,
    showPropertyConfirmModal,
    handlePropertyConfirmYes,
    handlePropertyConfirmNo
  } = usePropertyData();

  // Single source of truth for the lock: the status on screen. Reading the
  // localStorage copy left a validated page rendering unlocked until a reload.
  const checkStatus = formData.propertyStatus === "Validated";
 useEffect(() => {
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";
    const isEditMode = searchParams.get("edit") === "true";
    if (isReadOnlyFromURL || isViewMode || checkStatus) {
      setIsReadOnly(true);
    } else {
      setIsReadOnly(false);
    }
  }, [checkStatus, searchParams]);
  const navigate = useNavigate();
  const bottomsBarButtons = [
    { label: "Save", onClick: handleUpdate, skipConfirmation: true, disabled: checkStatus  },
    { label: "Validate & Lock", onClick: handleValidate , disabled: checkStatus},
    {
      label: "Back",
      onClick: () => navigate(`/transaction-detail?${searchParams.toString()}`),
      style: {},
      title: "Go back",
      disabled: false,
    },
    { label: "Next", onClick: handleNext },
    
  ];

  const renderModal = () =>
    modalOpen && (
      <ConfirmationModal isOpen={modalOpen} modalHeading={modalHeading} modalMessage={modalMessage} onClick={() => setModalOpen(false)} />
    );

  const isEntityIdMissing = useMemo(() => {
       return entityId === null || entityId === undefined || entityId === "" || entityId === "None";
     } ,[formData.entityId])
 

  return (
    <>
      {/* Right Sidebar */}
      

      <div className={!isReport ? "transaction-detail" : ""}>
        {!isReport && <StepTabs
          hasUnsavedChanges={hasUnsavedChanges}
          searchParams={searchParams}
          activeTab={activeTab}
          isEntityIdMissing={isEntityIdMissing}
          onTabChange={(tabId) => setActiveTab(tabId)}
        />}
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={formData?.propertyStatus}
        />

        {/* Main Form */}
        <div className="form-section">
        <div className="transaction-form">
          
          <PropertyInfoForm
            formData={formData}
            existingProperty={existingProperty}
            handleChange={handleChange}
            handlePropertyChange={handlePropertyChange}
            isReadOnly={isReadOnly || isReport}
            isSelectorReadOnly={isSelectorReadOnly}
            countries={countries}
            isReport={isReport}
            handleUpdate={handleUpdate}
          />
        </div>
        {!isReport && <RightSidebar />}
        </div>
      </div>

      {/* Bottom Bar */}


  
      {!isReport && <BottomBar buttons={bottomsBarButtons} />}
      {/* Modal - Uses createPortal to appear on top of everything */}
      {renderModal()}
      {/* Address Update Confirmation Modal */}
      {(modalOpen || showAddressModal) && (
        <Modal
         modalHeading={`Address Validation`}
          modalMessage={
            showAddressModal && validationResult ? (
              <AddressUpdateConfirmationModal
              formData={formData}
              updatedData={pendingUpdatedData}
              onContinue={validationResult.handleContinue}
              onDiscard={validationResult.handleDiscard}
              />
            ) : (
              modalMessage
            )
          }
          onClick={() => {
            if (modalOpen) setModalOpen(false);
            if (showAddressModal) setShowAddressModal(false);
          }}
        />
        )}

        <PropertyConfirmModal
          isOpen={showPropertyConfirmModal}
          onYes={handlePropertyConfirmYes}
          onNo={handlePropertyConfirmNo}
        />

        <FloatingQueryCenter/>

    </>
  );
};

export default PropertyInfo;
